// ConfirmAlert.js
import Swal from 'sweetalert2';

const ConfirmAlert = {
  async show(options) {
    const defaultOptions = {
      title: '¿Estás seguro?',
      showCancelButton: true,
      confirmButtonText: 'Sí',
      cancelButtonText: 'No',
    };

    const result = await Swal.fire({ ...defaultOptions, ...options });
    return result.isConfirmed;
  },

  async success(message) {
    await Swal.fire('Éxito', message, 'success');
  },

  async autoCloseSuccess(message, time = 2000) {
    await Swal.fire({
      title: message,
      timer: time,
      timerProgressBar: true,
      icon: 'success',
      showConfirmButton: false,
    });
  },

  async autoCloseError(message, time = 2000) {
    await Swal.fire({
      title: message,
      timer: time,
      timerProgressBar: true,
      icon: 'error',
      showConfirmButton: false,
    });
  },

  async error(message) {
    await Swal.fire('Error', message, 'error');
  },

  async info(message) {
    await Swal.fire('Información', message, 'info');
  },

  async warning(message) {
    await Swal.fire('Advertencia', message, 'warning');
  },

  async question(message) {
    await Swal.fire('Pregunta', message, 'question');
  },

  async autoClose(message, time = 2000) {
    await Swal.fire({
      title: message,
      timer: time,
      timerProgressBar: true,
    });
  },

  async input(prompt) {
    const result = await Swal.fire({
      title: 'Entrada',
      input: 'text',
      inputLabel: prompt,
      showCancelButton: true,
    });
    return result.value;
  },
  async errorsList(errors) {
    const htmlList = `<ul style='text-align: left;'>${errors.map(error => `<li>${error}</li>`).join('')}</ul>`;
    await Swal.fire({
        title: 'Error',
        html: htmlList,
        icon: 'error',
        showConfirmButton: true
    });
  },
  async successList(lists) {
    const htmlList = `<ul style='text-align: left;'>${lists.map(list => `<li>${list}</li>`).join('')}</ul>`;
    await Swal.fire({
        title: 'Éxito',
        html: htmlList,
        icon: 'success',
        showConfirmButton: true
    });
  },
  async informacionCargarCFDI(titulo, totalCFDI, totalCFDIRechazados, totalCFDIAceptados){
    Swal.fire({
      title: titulo,
      icon: "info",
      html: `
        <table style="margin: 0 auto; border-collapse: collapse;">
          <tbody>
            <tr>
              <td>Total CFDI enviados:</td><td>${totalCFDI}</td>
            </tr>
            <tr>
              <td>Aceptados:</td><td style="color: #34C38F; font-weight: bold;">${totalCFDIAceptados}</td>
            </tr>
            <tr>
              <td>Rechazados:</td><td style="color: #F46A6A; font-weight: bold;">${totalCFDIRechazados}</td>
            </tr>
          </tbody>
        </table>
      `,
      showConfirmButton: true,
    });
  }
  
  // ... más métodos según sea necesario
};

export default ConfirmAlert;